<div class="scope-parameters">
    <div [ngClass]="{ disabled: !item.is_ab_tested }">
        <app-tooltip [message]="'offers.list.is-ab-tested'" position="left">
            <i class="i i-ab-testing"></i>
        </app-tooltip>
    </div>

    <div [ngClass]="{ disabled: !isAudienceTargeted }">
        <app-tooltip [message]="'offers.list.is-targeted'" position="left">
            <i class="i i-target"></i>
        </app-tooltip>
    </div>

    <div [ngClass]="{ disabled: !item.loyalty_transaction_frequency }">
        <app-tooltip position="left" [message]="'offers.list.is-frequency'" [params]="{ frequency: item.loyalty_transaction_frequency  }">
            <i class="i i-frequency"></i>
        </app-tooltip>
    </div>

    <div [ngClass]="{ disabled: !item.is_main_source_transaction }" *ngIf="hasTransactionSource && item.is_main_source_transaction !== undefined">
        <app-icon-transaction-source></app-icon-transaction-source>
    </div>
</div>
